// List of body part- or accessory ids that should be mirrored

import { BPID } from "../enums/BodyPartIdEnum";
import { AID } from "../enums/AccessoryIdEnum";

export const MirrorParts = {
    [BPID.LEG_LEFT]: [ BPID.LEG_RIGHT ],
    [BPID.ARM_LEFT]: [ BPID.ARM_RIGHT ],
    [BPID.EAR_LEFT]: [ BPID.EAR_RIGHT ],
    [AID.SHOE_LEFT]: [ AID.SHOE_RIGHT ],
}